import { useTranslation } from 'react-i18next';
import type { EyeExaminationDisplayStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

const TONES: Record<EyeExaminationDisplayStatus, 'warning' | 'success' | 'danger' | 'neutral'> = {
  DRAFT: 'warning',
  COMPLETED: 'success',
  VOIDED: 'danger',
  REPLACED: 'neutral',
  DISCARDED: 'neutral',
};

/** The status as the API derives it for display. Replaced and discarded are voided examinations told apart by how they ended. */
export function ExaminationStatusBadge({ status }: { status: EyeExaminationDisplayStatus }) {
  const { t } = useTranslation();
  return <Badge tone={TONES[status]}>{t(`medical.status.${status}`)}</Badge>;
}
